import _ from 'lodash';
import numeral from 'numeral';

// eslint-disable-next-line import/prefer-default-export
export function currency({ amount, emptyDisplay = '- - - -', trimTrailingZeros = false }) {
    const floatAmount = parseFloat(amount, 10);
    if (_.isNaN(floatAmount)) {
        return emptyDisplay;
    }

    const currencyFormat = trimTrailingZeros && floatAmount % 1 === 0 ? '$0,0' : '$0,0.00';

    return numeral(floatAmount).format(currencyFormat);
}
